import React from 'react';
import { Beacon } from 'types/beacon';
import { getValueSafely } from 'utils/utils';

export default function AccuracyRangeSpan({ beacon }: { beacon: Beacon }) {
  const accuracyRangeString = getValueSafely(
    beacon.location?.uncertainty?.toFixed(1),
    ' metres',
  );

  return <span>{accuracyRangeString}</span>;
}
